<template>
    <div class="wrapper">
        <h2>General settings</h2>

        <section v-for="(item, index) in settings" v-bind:key="index">
            <custom-input
                        v-if="libraryVersion >= item.version[0] && (item.version[1] ? libraryVersion <= item.version[1] : true)"
                        :label="item.label"
                        :name="item.name"
                        :type="item.type"
                        :placeholder="item.placeholder"
                        v-model="instance[item.model]"
                        v-validate="item.validation"
            />
        </section>

        <custom-input label="Api Domain"
                      name="ApiDomain"
                      ref="apiDomain"
                      type="text"
                      placeholder="https://www.irischat.com"
                      v-model="apiDomain"
                      v-validate="{required: true}"
        />

        <custom-input label="Room Number"
                      type="display"
                      name="RoomNumber"
                      ref="roomNumber"
                      v-model="roomNumber"
        />

        <button class="primary" type="button" v-on:click="validation">Save</button>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput';

export default {
    name: 'settingsGeneral',
    mixins: [
        Default
    ],
    props: ['libraryVersion'],
    components: {
        customInput
    },
    data() {
        return {
            apiDomain: 'thisWillMeSomeDomain',
            roomNumber: '',
            settings: [
                { // ApiDomain
                    'version': ['1.0.1', '1.0.5'],
                    'label': 'testLabel - only visible in version 1.0.1 till 1.0.5',
                    'name': 'testName',
                    'type': 'text',
                    'placeholder': 'placeholderTest',
                    'model': 'apiDomain',
                    'validation': 'required'
                },
                { // RoomNumber
                    'version': ['1.0.6'],
                    'label': 'testLabel2 - only visible in version 1.0.6 and later',
                    'name': 'testName2',
                    'type': 'text',
                    'placeholder': 'placeholderTest2',
                    'model': 'apiDomain',
                    'validation': 'required'
                }
            ],
            instance: this
        };
    },
    created: function() {
        // - this.roomNumber = this.storage.getFromStorage('identification');
    },
    methods: {
        validation: function() {
            this.$parleyAdmin.validateMultiple([this.$refs.apiDomain, this.$refs.roomNumber], function(value) {
                if (!value)
                    return;

                alert('NOT IMPLEMENTED');
            });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
